<template>
  <div class="lending-term-cemar" v-if="manufacturer" style="margin: 0.5cm;">
    <HeaderTerm
      title="Termo Comodato"
      imgsrc="/static/img/cema-logo.png"
      :event-id="ticket.eventId"
      :ticket-id="ticket._id"
    />
    <div class="row">
      <div class="col-xs-12">
        <p>
          A {{ company }}, pessoa jurídica de direito privado, com sede em {{ address }}, inscrita no CNPJ sob o no. {{ cpnj }} e Inscrição Estadual doravante denominada {{ shortname }}, e o(a) <span class="captalize"><strong> {{ customer.holder }} </strong> </span> , residente e domiciliado(a) na <strong>{{ customer.address.street }}, {{ customer.address.number }}, {{ customer.address.complement }} - {{ customer.address.neighborhood }} - {{ customer.address.zip }}</strong>, na cidade de <strong>{{ customer.address.city }}</strong>, Maranhão, C/C n.o {{ customer.uc }}, firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:
        </p>
        <h5>CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES</h5>
        <ol id="ol-first">
          <li>
            A {{ shortname }} está desenvolvendo o "{{ config.name }}" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;
          </li>
          <li>
            No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;
          </li>
          <li>
            A {{ shortname }} buscando viabilizar essa prática nas comunidades atendidas pelo "{{ config.name }}", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento.
          </li>
        </ol>

        <h5>CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO</h5>
        <ol id="ol-second">
          <li>
            A {{ shortname }} substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da {{ shortname }};
          </li>
          <li>
            A geladeira entregue pela {{ shortname }} ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.
          </li>
          <li>
            Ao serem entregues a novas geladeiras pela {{ shortname }}, o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da <strong>3E Engenharia</strong>;
          </li>
          <li>
            Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela {{ shortname }} em comodato, passa a ser de propriedade do consumidor;
          </li>
          <li>
            O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a {{ shortname }}.
          </li>
        </ol>

        <h5>CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR</h5>
        <ol id="ol-third">
          <li>
            O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto {{ shortname }} Comunidades” cancelados, sendo a geladeira objeto do comodato em referência, recolhida imediatamente pela {{ shortname }};
          </li>
          <li>
            O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da {{ shortname }}, para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia” cancelados.
          </li>
        </ol>

        <h5>CLÁUSULA QUARTA </h5>
        <ol id="ol-fourth">
          <li>
            O donatário(a) declara ter recebido um refrigerator, com as especificações acima citadas, e se compromete a não vender, trocar ou negociar de qualquer forma o refrigerador recebido, sobe pena de reversão do bem doado
          </li>
        </ol>

        <h5>CLÁUSULA QUINTA</h5>
        <ol id="ol-fifth">
          <li>
            O equipamento doado tem garantia de 12 (doze) meses dada pelo fabricante {{ manufacturerName }}.
          </li>
        </ol>

        <h5>CLÁUSULA SEXTA</h5>
        <ol id="ol-sixth">
          <li> {{ manufacturerInformative }} </li>
        </ol>
        <p>
          <span class="captalize">{{ customer.address.city }}</span> , {{ new Date | moment('LLL') }}
        </p>
      </div>
    </div>
    <SignatureCustomerTicket :customer="customer" />
  </div>
</template>
<script>
import HeaderTerm from '../HeaderTerm'
import SignatureCustomerTicket from '../../SignatureCustomerTicket'

export default {
  name: 'lending-term-cemar',
  components: {
    SignatureCustomerTicket,
    HeaderTerm
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      company: 'Companhia Energética do Maranhão - CEMAR',
      shortname: 'CEMAR',
      address: 'Alameda A, Quadra SQS, no. 100, Loteamento Quitandinha – Altos do Calhau',
      cpnj: '06.272.793/0001-84',
      stateRegistration: '06.105.848-3'
    }
  },
  computed: {
    manufacturerInformative () {
      return this.manufacturer.informativeText ? this.manufacturer.informativeText : '-'
    },

    manufacturerName () {
      return this.manufacturer.name ? this.manufacturer.name : '-'
    }
  }
}
</script>
<style scoped>
  h5 {
    font-size: 11px !important;
  }
  p, ol, li {
    font-size: 10px !important;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .captalize {
    text-transform: capitalize;
  }

  p, li {
    font-size: 10pt;
    text-align: justify;
  }

  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 2cm;
    width: 25%;
  }

  .sign-line {
    border-bottom: 2px solid #000;
    margin-bottom: 10px;
    margin-top: 60px;
  }

  ol {
    counter-reset: number;
  }

  li {
    list-style: none;
    counter-increment: number;
  }

  li:before {
    font-weight: bold
  }

  #ol-first li:before {
    content: "1." counter(number) ". ";
  }
  #ol-second li:before {
    content: "2." counter(number) ". ";
  }
  #ol-third li:before {
    content: "3." counter(number) ". ";
  }
  #ol-fourth li:before {
    content: "4." counter(number) ". ";
  }
  #ol-fifth li:before {
    content: "5." counter(number) ". ";
  }
  #ol-sixth li:before {
    content: "6." counter(number) ". ";
  }
  @page
  {
      size: auto;   /* auto is the current printer page size */
      margin: 1cm;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/Cemar/LendingTermCemar.vue